const readCoordinate = (value: number | (() => number)): number => {
  return typeof value === 'function' ? value() : value;
};

const getLatLng = (
  result: google.maps.GeocoderResult,
): Promise<{ lat: number; lng: number }> => {
  const location = result.geometry?.location;

  if (!location) {
    return Promise.reject(new Error('Geocoder result has no location'));
  }

  return Promise.resolve({
    lat: readCoordinate(location.lat),
    lng: readCoordinate(location.lng),
  });
};

export default getLatLng;
